<template>
  <modal
    size="small"
    @close-modal="closeModal"
    :submit="false"
    :labels="{cancel: 'Fechar'}">

    <div slot="header">
      {{ userName }} é seguido por
    </div>
    <div slot="content">
      <div class="list-block -small Compartilhar">
          <div class="item -flex" v-for="follower in followers">
            <div class="UserBox -small">
              <a :href="follower.link" class="UserBox__avatar" :title="follower.nome">
                <img class="UserBox__image" :src="follower.imagem" :alt="follower.nome">
              </a>
                <div class="UserBox__body">
                    <a class="link -dark -bold" :href="follower.link" :title="follower.nome">
                        {{ follower.nome }}
                        <p class="UserBox__description">
                            {{ follower.nome_ocupacao }}
                        </p>
                    </a>
                </div>
              </div>
              <div v-if="follower.id != authUserId">
                <button class="btn" :class="{'-outline': !follower.seguido_por_usuario_logado}" @click="seguir(follower)">{{ follower.seguido_por_usuario_logado ? 'Seguindo' : 'Seguir' }}</button>
              </div>
          </div>
      </div>
    </div>
  </modal>
</template>

<script>
  export default {
    props: ['followers', 'userName', 'authUserId'],
    data() {
      return {
      }
    },
    methods: {
      closeModal() {
        this.$emit('close-modal');
      },
      toggle(user) {
          user.seguido_por_usuario_logado = !user.seguido_por_usuario_logado;
      },
      seguir(user) {
        let url;
        if (user.seguido_por_usuario_logado) url = '/ajax/deixar-seguir';
        else url = '/ajax/seguir';
        this.toggle(user);

        axios.post(url, {
          id: user.id,
          tipo: 'Usuario'
        })
          .then(({data}) => {
              if (data.status != 'success')
                  this.toggle(user);

          })
          .catch(err => this.toggle(user));
      }
    }
  }
</script>
